module.exports = __webpack_public_path__ + "static/media/red.b3fd587b.svg";